import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { CpmService } from '../../service/cpm.service'
import { PdfChart } from '../../shared/pdfChart'

import { ActivatedRoute } from '@angular/router'
import 'rxjs/add/operator/map'
import { ExportExcelService } from 'app/service/export-excel.service'
@Component({
  selector: 'app-sector-profit-data',
  templateUrl: './sector-profit-data.component.html',
  styleUrls: ['./sector-profit-data.component.scss']
})
export class SectorProfitDataComponent implements OnInit, AfterViewInit {
  totalprofitChgYoy: any
  totalprofitChgFullYear: any
  totalretainEarning: any
  totaldeRatio: any
  totalprofit: any
  totalebit: any
  totalsale: any
  endYear
  startYear
  tradingDate

  listStockQuote = []
  table
  example
  radios = [
    { value: 'L', des: 'View latest financial info' },
    { value: 'P', des: 'View by trend of profits' }
  ]
  viewValue = 'L'
  form: FormGroup
  pdfChart: PdfChart = new PdfChart()
  total
  totalIndexName
  totalDividendYield
  totalMarketCap
  totalAvgTradingValue
  totalnoOfReportCompany
  totalnoOfListedCompany
  listfinStatAnnual = []
  listfinStatCurrent = []
  listSet = []
  listMai = []
  quarter = ['3M', '6M', '9M']
  headerTrendProfits = []
  headerfinStatAnnual = []
  headerfinStatCurrent = []
  setMarket
  maiMarket
  npgMarket
  getPrint
  listProfitData = []
  print
  ws_data
  asOf = []
  headerTable = [
    '',
    'Indices',
    'Last price (pts)',
    'Index change 1D (%)',
    'Index change YTD (%)',
    'Index change 1Y (%)',
    'Dividend (%)',
    'Last P/E (X)',
    'Last market cap (M.Baht)',
    'Market cap (% weight)',
    'Avg trading YTD (M.Baht) '
  ]

  headerTableForPrint = [
    'Indices',
    'Last price (pts)',
    'Index change 1D (%)',
    'Index change YTD (%)',
    'Index change 1Y (%)',
    'Dividend (%)',
    'Last P/E (X)',
    'Last market cap (M.Baht)',
    'Market cap (% weight)',
    'Avg trading YTD (M.Baht) '
  ]

  headerTableExcel = [
    'Market',
    'Industry',
    'Sector',
    'Last price (pts)',
    'Index change 1D (%)',
    'Index change YTD (%)',
    'Index change 1Y (%)',
    'Dividend (%)',
    'Last P/E (X)',
    'Last market cap (M.Baht)',
    'Market Cap (% weight)',
    'Avg trading YTD (M.Baht) '
  ]

  headerFinancialInfor = [
    'Indices',
    '#Comp',
    'Sales (M.Baht)',
    'EBIT (M.Baht)',
    'Profits (M.Baht)'
  ]
  asc = 1
  desc = -1
  constructor(
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService,
    private excelService: ExportExcelService
  ) { }

  ngOnInit() {
    const { radioByView } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    this.getPrint = print
    this.pdfChart.setPdf(pdf)

    radioByView === undefined
      ? (this.viewValue = 'L')
      : (this.viewValue = radioByView)
    this.print = print

    this.form = new FormGroup({
      radioValue: new FormControl(this.viewValue)
    })

    this.getLastTradingDate().then(endYear =>
      this.loadDataFromGetLastTradingDate(endYear)
    )
    this.getIndustryStatistic()

    localStorage.setItem('sectorProfitDataPrint', 'false')
    this.totalIndexName = 'Grand total'
  }

  printSectorProfitData() {
    const popupWin = window.open(
      `/#/sectorProfitData/${this.viewValue}`,
      '_blank',
      'width=720px,height=1024px'
    )
  }

  changedEvent(event) {
    $(event.target)
      .parents()
      .next('.hide')
      .toggle()
  }

  popupTotalEvent() {
    window.open(`/#/sectorPopup/top/sale`);
  }

  popupEvent(marketName, type, indexName) {
    if (indexName === 'NPG') window.open(`/#/sectorPopup/top/sale/${marketName}/Sector/${encodeURIComponent(indexName)}`);
    else window.open(`/#/sectorPopup/top/sale/${marketName}/${type}/${encodeURIComponent(indexName)}`);
  }

  isLastyear() {
    return this.viewValue === 'L'
  }
  isHeaderLastyear() {
    return this.viewValue === 'L'
  }

  async getIndustryStatistic() {
    this.listStockQuote = await this.cpmService
      .getIndustryStatistic()
      .then(obj => {
        return obj
      })

    this.setMarket = this.listStockQuote.find(obj => obj.indexName === 'SET')
    this.maiMarket = this.listStockQuote.find(obj => obj.indexName === 'mai')
    this.npgMarket = this.listStockQuote.find(obj => obj.indexName === 'NPG')

    const filters = {
      marketName: '',
      type: 'Industry'
    }

    filters.marketName = 'SET'
    this.listSet = this.multiFilter(this.listStockQuote, filters)
    let headerList = []
    headerList = this.listSet.map((header, i) => {
      header['finStatCurrentSize'] = header.finStatCurrent.length


      header['finStatAnnualSize'] = header.finStatAnnual.length

      return header
    })
    headerList = this.sortList(headerList, 'finStatAnnualSize', this.desc)
    headerList = this.sortList(headerList, 'finStatCurrentSize', this.desc)
    if (this.listSet.length > 0) {
      this.headerTrendProfits.push('Indices')
      this.headerTrendProfits.push('#Comp')
      this.listSet[0].finStatAnnual.map(obj => {
        const headerTrename = obj.year.toString() + '    (M.Baht)'
        this.asOf.push('12M ' + obj.year)
        this.headerfinStatAnnual.push(obj.year)
        this.headerTrendProfits.push(headerTrename)
      })
      this.headerTrendProfits.push('Full year change (%yoy)')
      headerList[0].finStatCurrent.map(obj => {
        this.headerfinStatCurrent.push(obj.year)
        this.headerTrendProfits.push(
          this.quarter[obj.quarter - 1] + '  ' + obj.year + '     (M.Baht)'
        )
        this.asOf.push(this.quarter[obj.quarter - 1] + ' ' + obj.year)
      })
      this.headerTrendProfits.push('Change (%yoy)')
      this.asOf = this.asOf[this.asOf.length - 1]
    }

    this.listSet = this.addfinStatCurrent(
      this.listSet,
      this.headerfinStatCurrent
    )
    this.listSet = this.addfinStatAnnual(
      this.listSet,
      this.headerfinStatAnnual
    )
    this.listSet = this.getChild(this.listSet)

    filters.marketName = 'mai'
    this.listMai = this.multiFilter(this.listStockQuote, filters)

    this.listMai = this.addfinStatCurrent(
      this.listMai,
      this.headerfinStatCurrent
    )
    this.listMai = this.addfinStatAnnual(
      this.listMai,
      this.headerfinStatAnnual
    )
    this.maiMarket = this.addfinStatCurrent(
      this.maiMarket,
      this.headerfinStatCurrent
    )
    this.maiMarket = this.addfinStatAnnual(
      this.maiMarket,
      this.headerfinStatAnnual
    )
    this.setMarket = this.addfinStatCurrent(
      this.setMarket,
      this.headerfinStatCurrent
    )
    this.setMarket = this.addfinStatAnnual(
      this.setMarket,
      this.headerfinStatAnnual
    )
    this.npgMarket = this.addfinStatCurrent(
      this.npgMarket,
      this.headerfinStatCurrent
    )
    this.npgMarket = this.addfinStatAnnual(
      this.npgMarket,
      this.headerfinStatAnnual
    )
    this.total = await this.getTotal()
    this.listProfitData.push(this.setMarket)
    this.listProfitData.push(...this.listSet)
    this.listProfitData.push(this.maiMarket)
    this.listProfitData.push(...this.listMai)
    this.listProfitData.push(this.npgMarket)
  }

  isClassLabel(type) {
    return type === 'Industry' || type === 'Market'
  }

  isSETMAI(indexName) {
    return indexName === 'SET' || indexName === 'mai' || indexName === 'NPG'
  }

  isstyleMarket(type) {
    let isMarket = false
    if (type === 'Market') {
      isMarket = false
    } else if (type !== 'Industry') {
      isMarket = true
    }
    if (this.print) {
      isMarket = false
    }
    return isMarket
  }

  getlistSector(marketName: String, industryName) {
    const filters = {
      marketName: marketName,
      type: 'Sector',
      industryName: industryName
    }
    let list = []
    if (industryName !== null) {
      list = this.multiFilter(this.listStockQuote, filters)
    }

    return list
  }

  multiFilter(array, filters) {
    const filterKeys = Object.keys(filters)
    return array.filter(item => {
      // dynamically validate all filter criteria
      // tslint:disable-next-line:no-bitwise
      return filterKeys.every(key => !!~filters[key].indexOf(item[key]))
    })
  }

  async getTotal() {
    const filters = {
      indexName: ['SET', 'mai', 'NPG']
    }

    const list = this.multiFilter(this.listStockQuote, filters)

    this.listfinStatAnnual = []
    this.listfinStatCurrent = []
    this.headerfinStatAnnual.map(annual => {
      const findAnnual = list[0]['finStatAnnual'].find(an => an.year === annual)
      const findAnnual1 = list[1]['finStatAnnual'].find(an => an.year === annual)
      const findAnnual2 = list[2]['finStatAnnual'].find(an => an.year === annual)
      const annualObj = {}
      annualObj['year'] = annual
      annualObj['profit'] = (findAnnual ? findAnnual.profit : 0) + (findAnnual1 ? findAnnual1.profit : 0) + (findAnnual2 ? findAnnual2.profit : 0)
      this.listfinStatAnnual.push(annualObj)
    })
    this.headerfinStatCurrent.map(annual => {
      const finStatCurrent = list[0]['finStatCurrent'].find(an => an.year === annual)
      const finStatCurrent1 = list[1]['finStatCurrent'].find(an => an.year === annual)
      const finStatCurrent2 = list[2]['finStatCurrent'].find(an => an.year === annual)
      if (finStatCurrent !== undefined) {
        const currentObj = {}
        currentObj['year'] = annual
        currentObj['profit'] =
          finStatCurrent.profit + (finStatCurrent1 !== undefined ? finStatCurrent1.profit : 0) + (finStatCurrent2 !== undefined ? finStatCurrent2.profit : 0)
        this.listfinStatCurrent.push(currentObj)
      }
    })

    const total = {}

    total['indexName'] = 'Grand total'

    total['dividendYield'] = list.reduce(function (a, b) {
      return a + b.dividendYield
    }, 0)

    this.totalDividendYield = list.reduce(function (a, b) {
      return a + b.dividendYield
    }, 0)

    total['marketCap'] = list.reduce(function (a, b) {
      return a + b.marketCap
    }, 0)
    this.totalMarketCap = list.reduce(function (a, b) {
      return a + b.marketCap
    }, 0)
    total['avgTradingValue'] = list.reduce(function (a, b) {
      return a + b.avgTradingValue
    }, 0)
    this.totalAvgTradingValue = list.reduce(function (a, b) {
      return a + b.avgTradingValue
    }, 0)
    total['noOfReportCompany'] = list.reduce(function (a, b) {
      return a + b.noOfReportCompany
    }, 0)
    total['noOfListedCompany'] = list.reduce(function (a, b) {
      return a + b.noOfListedCompany
    }, 0)

    this.totalnoOfReportCompany = list.reduce(function (a, b) {
      return a + b.noOfReportCompany
    }, 0)
    this.totalnoOfListedCompany = list.reduce(function (a, b) {
      return a + b.noOfListedCompany
    }, 0)

    total['sale'] = list.reduce(function (a, b) {
      return a + b.sale
    }, 0)
    total['ebit'] = list.reduce(function (a, b) {
      return a + b.ebit
    }, 0)
    total['profit'] = list.reduce(function (a, b) {
      return a + b.profit
    }, 0)
    total['deRatio'] = list.reduce(function (a, b) {
      return a + b.deRatio
    }, 0)
    total['retainEarning'] = list.reduce(function (a, b) {
      return a + b.retainEarning
    }, 0)

    this.totalsale = list.reduce(function (a, b) {
      return a + b.sale
    }, 0)
    this.totalebit = list.reduce(function (a, b) {
      return a + b.ebit
    }, 0)
    this.totalprofit = list.reduce(function (a, b) {
      return a + b.profit
    }, 0)
    this.totaldeRatio = list.reduce(function (a, b) {
      return a + b.deRatio
    }, 0)
    this.totalretainEarning = list.reduce(function (a, b) {
      return a + b.retainEarning
    }, 0)

    this.totalprofitChgFullYear = this.calFullYearchg(this.listfinStatAnnual)
    this.totalprofitChgYoy = this.calChgYoy(this.listfinStatCurrent)

    total['profitChgFullYear'] = this.totalprofitChgFullYear
    total['profitChgYoy'] = this.totalprofitChgYoy
    total['finStatAnnual'] = this.listfinStatAnnual
    total['finStatCurrent'] = this.listfinStatCurrent

    return total
  }

  getChild(listMaster) {
    const listSelect = []
    listMaster.map(obj => {
      const filtersx = {
        industryName: obj.indexName,
        type: 'Sector',
        marketName: obj.marketName
      }
      const objKey1 = {}
      Object.keys(obj).map(key => {
        objKey1[key] = obj[key]

        if (key === 'finStatAnnual') {
          const listfinStatAnnual = []
          listfinStatAnnual.push(...obj['finStatAnnual'])
          this.headerfinStatAnnual.map(annual => {
            const findAnnual = listfinStatAnnual.find(an => an.year === annual)
            if (findAnnual === undefined) {
              const annualObj = {}
              Object.keys(obj['finStatAnnual'][0]).map(keyAn => {
                annualObj[keyAn] = 0
              })
              annualObj['year'] = annual
              objKey1[key].push(annualObj)
            }
          })
          objKey1[key].sort((obj1, obj2) => {
            if (obj1.year > obj2.year) {
              return 1
            }
            if (obj1.year < obj2.year) {
              return -1
            }
            return 0
          })
        }
      })

      listSelect.push(objKey1)
      let list = []
      list = this.multiFilter(this.listStockQuote, filtersx)
      if (!!list) {
        // if (!!list.length > 0) {

        list.map(t => {
          if (t.finStatAnnual.length === 0) {
            this.headerfinStatAnnual.map(annual => {
              const annualObj = {}
              Object.keys(obj['finStatAnnual'][0]).map(keyAn => {
                annualObj[keyAn] = 0
              })
              annualObj['year'] = annual
              t.finStatAnnual.push(annualObj)
            })
          }
          if (t.finStatCurrent.length === 0) {
            this.headerfinStatCurrent.map(annual => {
              const currentObj = {}
              Object.keys(obj['finStatCurrent'][0]).map(keyAn => {
                currentObj[keyAn] = 0
              })
              currentObj['year'] = annual
              t.finStatCurrent.push(currentObj)
            })
          }
        })

        const objKey = {}
        Object.keys(obj).map(key => {
          objKey[key] = obj[key]
        })

        list = this.addfinStatCurrent(list, this.headerfinStatCurrent)
        objKey['type'] = 'list'
        objKey['list'] = list
        listSelect.push(objKey)
      }
    })

    return listSelect
  }

  isMarketNameMai(marketName, indexName) {
    return marketName === 'SET' && indexName !== 'SET' && indexName !== 'NPG'
  }

  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'negative' : 'positive'
  }

  dataToExcel() {
    this.ws_data = []
    const optionHeader = this.isLastyear()
      ? this.headerFinancialInfor
      : this.headerTrendProfits
    this.ws_data.push([...this.headerTableExcel, ' ', ...optionHeader])
    const totalData = this.industryData(this.total, true)
    this.ws_data.push(totalData)
    let data = []
    this.listProfitData.map(industry => {
      if (this.isClassLabel(industry.type)) {
        data = this.industryData(industry, '')
        for (let i = 0; i < data.length; i++) {
          if (!data[i]) data[i] = null;
        }
        this.ws_data.push([...data])
      } else {
        industry.list.map(industryObj => {
          data = this.industryData(industryObj, '')
          for (let i = 0; i < data.length; i++) {
            if (!data[i]) data[i] = null;
          }
          this.ws_data.push([...data])
        })
      }
    })

    this.excelService.exportExcelSectorIndexandProfit(
      this.ws_data,
      'Sector index & Profit'
    )
  }

  industryData(industryObj, total) {
    const num =
      industryObj.noOfReportCompany === 0 ||
        industryObj.noOfReportCompany === null
        ? '-'
        : industryObj.noOfReportCompany
    const numberOf = num + '/' + industryObj.noOfListedCompany
    let data = []

    if (total) {
      data = [
        industryObj.indexName,
        '',
        '',
        '',
        '',
        '',
        '',
        parseFloat(industryObj.dividendYield),
        '',
        parseFloat(industryObj.marketCap),
        100.0,
        parseFloat(industryObj.avgTradingValue),
        '',
        industryObj.indexName,
        numberOf
      ]
    } else {
      const marketName =
        industryObj.type === 'Market' ? industryObj.indexName : ' '
      const industryName =
        industryObj.type === 'Industry' ? industryObj.indexName : ' '
      const sectorName =
        industryObj.type === 'Sector' ? industryObj.indexName : ' '
      data = [
        marketName,
        industryName,
        sectorName,
        parseFloat(industryObj.indexClose),
        parseFloat(industryObj.indexChg1D),
        parseFloat(industryObj.indexChgYtd),
        parseFloat(industryObj.indexChg1Y),
        parseFloat(industryObj.dividendYield),
        parseFloat(industryObj.pe),
        parseFloat(industryObj.marketCap),
        parseFloat(industryObj.marketCapWeight),
        parseFloat(industryObj.avgTradingValue),
        '',
        industryObj.indexName,
        numberOf
      ]
    }
    if (this.isLastyear()) {
      const sale =
        industryObj.sale === 0 || industryObj.sale === null
          ? null
          : parseFloat(industryObj.sale)
      const ebit =
        industryObj.ebit === 0 || industryObj.sale === null
          ? null
          : parseFloat(industryObj.ebit)
      const profit =
        industryObj.profit === 0 || industryObj.sale === null
          ? null
          : parseFloat(industryObj.profit)
      data.push(sale)
      data.push(ebit)
      data.push(profit)
    } else {
      industryObj.finStatAnnual.map(finStatAn => {
        const finStat =
          finStatAn.profit === 0 || finStatAn.profit === null
            ? null
            : parseFloat(finStatAn.profit)
        data.push(finStat)
      })
      const profitChgYear =
        industryObj.profitChgFullYear === 0 ||
          industryObj.profitChgFullYear === null
          ? null
          : parseFloat(industryObj.profitChgFullYear)
      data.push(profitChgYear)
      industryObj.finStatCurrent.map(finStatAn => {
        const finStatcur =
          finStatAn.profit === 0 || finStatAn.profit === null
            ? null
            : parseFloat(finStatAn.profit)
        data.push(finStatcur)
      })
      const profitChgYoy =
        industryObj.profitChgYoy === 0 || industryObj.profitChgYoy === null
          ? null
          : parseFloat(industryObj.profitChgYoy)
      data.push(profitChgYoy)
    }

    return data
  }

  loadDataFromGetLastTradingDate(endYear) {
    this.endYear = endYear
    this.startYear = +this.endYear - 4
  }
  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }
  getBackground(name, marketId) {
    const list2 = ['S']
    const index = list2.findIndex(obj => obj === marketId)
    return index >= 0 ? true : false
  }

  onChangeDate() { }

  calFullYearchg(listfinStatAnnual) {
    if (listfinStatAnnual.length > 2) {
      return (
        ((listfinStatAnnual[listfinStatAnnual.length - 1].profit -
          listfinStatAnnual[listfinStatAnnual.length - 2].profit) /
          Math.abs(listfinStatAnnual[listfinStatAnnual.length - 2].profit)) *
        100
      )
    }
    return 0
  }

  calChgYoy(listfinStatCurrent) {
    if (listfinStatCurrent.length > 1) {
      return (
        ((listfinStatCurrent[listfinStatCurrent.length - 1].profit -
          listfinStatCurrent[listfinStatCurrent.length - 2].profit) /
          Math.abs(listfinStatCurrent[listfinStatCurrent.length - 2].profit)) *
        100
      )
    }
    return 0
  }

  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }

  addfinStatAnnual(list, headerfinStatAnnual) {
    const annualObj = {
      year: 0,
      quarter: 0,
      sale: null,
      ebit: null,
      profit: null,
      deRatio: null,
      retainEarning: null
    }
    headerfinStatAnnual.map(year => {
      let quarter
      if (!Array.isArray(list)) {
        const statAnnual = list.finStatAnnual.find(
          current => current.year === year
        )
        if (!!statAnnual) {
          quarter = statAnnual.quarter
        } else {
          annualObj['year'] = year
          annualObj['quarter'] = quarter
          list.finStatAnnual.push(annualObj)
        }
      } else {
        list.map(set => {
          const statAnnual = set.finStatAnnual.find(
            current => current.year === year
          )
          if (!!statAnnual) {
            quarter = statAnnual.quarter
          } else {
            annualObj['year'] = year
            annualObj['quarter'] = quarter
            set.finStatCurrent.push(annualObj)
          }
        })
      }
    })
    return list
  }

  addfinStatCurrent(list, headerfinStatCurrent) {
    const currentObj = {
      year: 0,
      quarter: 0,
      sale: null,
      ebit: null,
      profit: null,
      deRatio: null,
      retainEarning: null
    }
    headerfinStatCurrent.map(year => {
      let quarter
      if (!Array.isArray(list)) {
        const statCurrent = list.finStatCurrent.find(
          current => current.year === year
        )
        if (!!statCurrent) {
          quarter = statCurrent.quarter
        } else {
          currentObj['year'] = year
          currentObj['quarter'] = quarter
          list.finStatCurrent.push(currentObj)
        }
      } else {
        list.map(set => {
          const statCurrent = set.finStatCurrent.find(
            current => current.year === year
          )
          if (!!statCurrent) {
            quarter = statCurrent.quarter
          } else {
            currentObj['year'] = year
            currentObj['quarter'] = quarter
            set.finStatCurrent.push(currentObj)
          }
        })
      }
    })
    return list
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 2500);
    }
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/sector-profit-data/sector-profit-data.component.ts